<div class="ck-backdrop" role="dialog" aria-modal="true" aria-label="¿Cómo te sientes hoy?">
  <div class="ck-card">
    <div class="ck-shapes" aria-hidden="true"><i class="ck-shape ck-shape--a"></i><i class="ck-shape ck-shape--b"></i></div>

    <!-- Breaky reacciona a lo que elijas -->
    <div class="ck-hero">
      <app-breaky [pose]="pose" [size]="132" motion="idle"></app-breaky>
      <div class="ck-bubble" [attr.data-has]="selectedMood ? 1 : 0">
        <strong>¿Cómo te sientes hoy?</strong>
        <span>{{ bubbleText }}</span>
      </div>
    </div>

    <!-- Estados de animo -->
    <div class="ck-moods" role="radiogroup" aria-label="Estado de ánimo">
      <button
        *ngFor="let m of moods"
        type="button"
        role="radio"
        class="ck-mood"
        [class.ck-mood--on]="selectedMood === m.key"
        [attr.aria-checked]="selectedMood === m.key"
        (click)="selectMood(m.key)"
      >
        <span class="ck-mood-emoji">{{ m.emoji }}</span>
        <span class="ck-mood-label">{{ m.label }}</span>
      </button>
    </div>

    <label class="ck-note">
      <span>¿Quieres añadir algo sobre tu día? <em>(opcional)</em></span>
      <textarea [(ngModel)]="comment" rows="2" maxlength="100" placeholder="Escribe lo que quieras..."></textarea>
      <small>{{ comment.length }} / 100</small>
    </label>

    <div class="ck-actions">
      <button type="button" class="ck-skip" (click)="closeModal.emit()">Ahora no</button>
      <button type="button" class="ck-save" (click)="saveCheckin()" [disabled]="!selectedMood || isSaving">
        {{ isSaving ? 'Guardando...' : 'Guardar mi check-in' }}
      </button>
    </div>
    <p class="ck-reward">🌿 Tu check-in diario suma Vitalis</p>
  </div>
</div>
